/**
 * Blocks Registry
 * Register all React and plain JS blocks/components
 */
import { ArticleCarousel } from "@/components/Articles/ArticleCarousel";
import { ArticleFeaturedListing } from "@/components/Articles/ArticleFeaturedListing";
import { CarouselSlider } from "@/components/carousel-slider/carousel-slider.component";
import { DropdownComponent } from "@/components/Dropdown/DropdownComponent";
import { FooterSection } from "@/components/footer-section/footer-section.component";
import { Header } from "@/components/header/header.component";
import { MultiLanguageDocumentDownload } from "@/components/MultiLanguageDocumentDownload/MultiLanguageDocumentDownload";
import { onceUserInteracts } from "@/utils";
import { componentRegistry } from "@/utils/block-registry.util";
import { Accordion } from "./AccordionBlock/Accordion";
import { BrandCategoryTabs } from "./BrandCategoryTabs";
import { CampaignFormCta } from "./CampaignFormCta";
import { CollapseContent } from "./CollapseContent";
import { CollectionExplorerTabs } from "./CollectionExplorerTabs";
import { EventTabs } from "./EventTabBlock";
import { HeroScrollIndicator } from "./HeroScrollIndicator";
import { HistoricalTimeline } from "./HistoricalTimeline";
import { PopupBlock } from "./PopupBlock";
import { ProcessSteps } from "./ProcessSteps";
import { RssListingAccordion } from "./RssListingAccordion";
import { VideoCustomControls } from "./VideoCustomControls";
/**
 * Register all blocks here
 */
export function registerAllComponents() {
    componentRegistry.register("CarouselSlider", CarouselSlider);
    componentRegistry.register("CampaignFormCta", CampaignFormCta);
    componentRegistry.register("Accordion", Accordion);
    componentRegistry.register("Header", Header);
    componentRegistry.register("FooterSection", FooterSection);
    componentRegistry.register("CollapseContent", CollapseContent);
    componentRegistry.register("VideoCustomControls", VideoCustomControls);
    componentRegistry.register("HeroScrollIndicator", HeroScrollIndicator);
    componentRegistry.register("VideoTextBlock", () => new Promise((resolve) => {
        onceUserInteracts(() => import("./VideoTextBlock").then(resolve));
    }));
    componentRegistry.register("TabGroup", () => import(/* webpackChunkName: "common" */ "@/components/TabGroup"));
    componentRegistry.register("ArticleFeaturedListing", ArticleFeaturedListing);
    componentRegistry.register("ArticleCarousel", ArticleCarousel);
    componentRegistry.register("DropdownComponent", DropdownComponent);
    componentRegistry.register("HistoricalTimeline", HistoricalTimeline);
    componentRegistry.register("ProcessSteps", ProcessSteps);
    componentRegistry.register("PopupBlock", PopupBlock);
    componentRegistry.register("ArticleListingWithFilters", () => import(/* webpackChunkName: "common" */ "./ArticleListingWithFilters"));
    componentRegistry.register("SearchPage", () => import("@/components/SearchPage/search-page.component"));
    componentRegistry.register("EventCollections", () => import("./EventCollectionBlock"));
    componentRegistry.register("BrandCategoryTabs", BrandCategoryTabs);
    componentRegistry.register("CollectionExplorerTabs", CollectionExplorerTabs);
    componentRegistry.register("EventTabs", EventTabs);
    componentRegistry.register("PublicationCollections", () => import(/* webpackChunkName: "common" */ "./PublicationCollection"));
    componentRegistry.register("RssListingAccordion", RssListingAccordion);
    componentRegistry.register("StoreLocator", () => import("@/components/StoreLocator/StoreLocator"));
    componentRegistry.register("MultiLanguageDocumentDownload", MultiLanguageDocumentDownload);
    componentRegistry.register("GalleryModalBlock", () => import("./GalleryModalBlock"));
}
